import { CampaignCardFooterProps } from './campaign-card-footer-types';
import {
    RewardsContainer,
    IconWrapper,
    BottomCampaignCard
} from './style-component';
import SpaceshipIcon from '@/assets/icons/spaceship-icon/spaceship-icon.svg';
import SpaceshipIconDark from '@/assets/icons/spaceship-icon-dark/spaceship-icon-dark.svg';
import { TimeInfo } from '@/components/time-info/time-info';
import { useTheme } from '@/contexts/theme-context/useThemeContext';
import { calculateTimeStatus } from '@/utils/calculate-time-status/calculate-time-status';
import ProgressBar from '@/components/progress-bar/progress-bar';
import { getTotalMissionsBasedOnEnv } from '@/utils/total-mission-based-on-env';

export const CampaignCardFooter: React.FC<CampaignCardFooterProps> = ({
    endDate,
    startDate,
    rewards,
    isCompleted,
    campaignId
}) => {
    const { current, total } = rewards;
    const newTotal = getTotalMissionsBasedOnEnv(campaignId ?? '', total)
    const theme = useTheme();


    //@ts-expect-error review this
    const status = calculateTimeStatus({
        startDate: startDate,
        endDate: endDate,
        isCompleted: isCompleted
    });

    return (
        <BottomCampaignCard>
            <TimeInfo
                isCampaign={true}
                endDate={endDate}
                startDate={startDate}
                status={status}
            />
            <RewardsContainer>
                <IconWrapper>
                    <img src={theme?.theme?.name === 'dark' ? SpaceshipIcon : SpaceshipIconDark} alt="rewards" />
                </IconWrapper>
                <ProgressBar 
                    progress={current} 
                    maxProgress={newTotal} 
                    minProgress={newTotal} 
                    status={current > 0 && newTotal > 0 && current >= newTotal ? 'completed':'inCourse'} 
                    isClaimed={false} 
                    isExChange={true}
                />
            </RewardsContainer>
        </BottomCampaignCard>
    );
};
